import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _SCHEMA_TYPES, _SCHEMAS;

export var TYPES = {
  CATEGORY: 'category',
  PRODUCT: 'product',
  AGGREGATE_OFFER: 'AggregateOffer',
  OFFER: 'offer',
  HOMEPAGE: 'homepage',
  ORGANISATION: 'organisation',
  SEARCH_ACTION: 'search-action'
};
var CONTEXT = 'http://schema.org';
var BRAND = 'Maisons du Monde';
var SCHEMA_TYPES = (_SCHEMA_TYPES = {}, _defineProperty(_SCHEMA_TYPES, TYPES.CATEGORY, 'Product'), _defineProperty(_SCHEMA_TYPES, TYPES.PRODUCT, 'Product'), _defineProperty(_SCHEMA_TYPES, TYPES.AGGREGATE_OFFER, 'AggregateOffer'), _defineProperty(_SCHEMA_TYPES, TYPES.OFFER, 'Offer'), _defineProperty(_SCHEMA_TYPES, TYPES.HOMEPAGE, 'WebSite'), _defineProperty(_SCHEMA_TYPES, TYPES.ORGANISATION, 'Organization'), _defineProperty(_SCHEMA_TYPES, TYPES.SEARCH_ACTION, 'SearchAction'), _SCHEMA_TYPES);

var getProductDescription = function getProductDescription(product) {
  if (product.additionalInformation.metaDescription) {
    return product.additionalInformation.metaDescription;
  }

  return product.description.main ? product.description.main.replace(/\n|\r|\t|<(?:.|\n)*?>/gm, '').trim().slice(0, 150) : '';
};

var getProductAvailability = function getProductAvailability(product) {
  if (product.stock.status === 'STORE_ONLY') {
    return 'InStoreOnly';
  }

  if (product.additionalInformation.buyable) {
    return 'InStock';
  }

  return 'OutOfStock';
};

var getProductPrice = function getProductPrice(_ref) {
  var price = _ref.price;
  return price.sales.amount ? "".concat(price.sales.amount) : "".concat(price.base.amount);
};

var SCHEMAS = (_SCHEMAS = {}, _defineProperty(_SCHEMAS, TYPES.CATEGORY, function (category, _ref2) {
  var currency = _ref2.currency;

  var _category$filters$fin = category.filters.find(function (_ref3) {
    var name = _ref3.name;
    return name === 'price';
  }),
      facets = _category$filters$fin.facets;

  return {
    '@context': CONTEXT,
    '@type': SCHEMA_TYPES[TYPES.CATEGORY],
    name: category.name,
    description: category.seo.meta_description,
    brand: BRAND,
    offers: {
      '@type': SCHEMA_TYPES[TYPES.AGGREGATE_OFFER],
      lowPrice: facets.min.toFixed(2),
      highPrice: facets.max.toFixed(2),
      offerCount: category.total,
      priceCurrency: currency
    },
    url: category.url,
    image: category.image
  };
}), _defineProperty(_SCHEMAS, TYPES.PRODUCT, function (product) {
  return {
    '@context': CONTEXT,
    '@type': SCHEMA_TYPES[TYPES.PRODUCT],
    name: product.name,
    description: getProductDescription(product),
    image: product.images[0].src,
    brand: BRAND,
    offers: {
      '@type': SCHEMA_TYPES[TYPES.OFFER],
      availability: getProductAvailability(product),
      price: getProductPrice(product),
      priceCurrency: product.currency,
      itemCondition: 'new'
    },
    url: product.url
  };
}), _defineProperty(_SCHEMAS, TYPES.HOMEPAGE, function (prismic, locale) {
  return {
    '@context': CONTEXT,
    '@type': SCHEMA_TYPES[TYPES.HOMEPAGE],
    url: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language),
    name: prismic.meta_title,
    image: prismic.thumbnail.url || '',
    publisher: {
      '@type': SCHEMA_TYPES[TYPES.ORGANISATION],
      name: BRAND
    },
    potentialAction: {
      '@type': SCHEMA_TYPES[TYPES.SEARCH_ACTION],
      target: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language, "/q/{search_term_string}"),
      'query-input': 'required name=search_term_string',
      keywords: prismic.keywords.map(function (_ref4) {
        var keyword = _ref4.keyword;
        return keyword;
      }).filter(function (keyword) {
        return keyword;
      }).join(),
      sameAs: prismic.sameAs.map(function (_ref5) {
        var url = _ref5.url.url;
        return url;
      }).filter(function (url) {
        return url;
      })
    }
  };
}), _SCHEMAS);

var undefinedSchema = function undefinedSchema(type) {
  return function () {
    return console.warn("Schema for \"".concat(type, "\" is not defined"));
  };
};

var getJsonLD = function getJsonLD(type) {
  return SCHEMAS[type] || undefinedSchema(type);
};

export default getJsonLD;